import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AlgoliaChemical } from '@context/shared/types/search';
import { TuiAvatar } from '@taiga-ui/kit';

@Component({
	imports: [TuiAvatar],
	selector: 'ctx-algolia-chemical-thumbnail',
	templateUrl: 'algolia-chemical-thumbnail.component.html',
	styleUrl: 'algolia-chemical-thumbnail.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlgoliaChemicalThumbnailComponent {
	readonly chemical = input.required<AlgoliaChemical>();
}
